import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, accessToken } = useSelector((state) => state.auth);
  
  // Vérifier à la fois isAuthenticated et accessToken
  const isAuth = isAuthenticated && accessToken;

  return isAuth ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;